module.exports = __webpack_public_path__ + "img/client-demo-product.21b76707.png";